import { CloseCircle, Tag } from "iconsax-react-nativejs";
import { Pressable, Text, View } from "react-native";
import { useTheme } from "react-native-paper";

type TagPillProps = Readonly<{
  tag: string;
  onRemove: (tag: string) => void;
  isEditing: boolean;
  /** Tapping the tag itself. Omitted while editing, where the tag is not a link. */
  onPress?: (tag: string) => void;
}>;

const TagPill = ({ tag, onRemove, isEditing, onPress }: TagPillProps) => {
  const label = (
    <Text className="text-sm italic text-primary hover:underline decoration-1">
      {'#'+tag}
    </Text>
  );

  return (
    <View
      className="flex-row items-center gap-1 rounded-full"
    >
      {onPress ? (
        <Pressable onPress={() => onPress(tag)} hitSlop={4}>
          {label}
        </Pressable>
      ) : (
        label
      )}
      {isEditing && (
        <Pressable onPress={() => onRemove(tag)} hitSlop={8} className="rounded-full hover:bg-ash-3">
          {({ hovered }) => (
            <CloseCircle
              size={20}
              color={hovered ? "var(--color-primary-default)" : "var(--color-ash-1)"}
            />
          )}
        </Pressable>
      )}
    </View>
  );
};

export default TagPill;
